import React, { Component } from "react";
import { connect } from "react-redux";
import "./content.scss";
import trendsIcon from "../../../assets/svg/trendBlue.svg";
import { Link } from "react-router-dom";
import { configure_progress, gettingStartedProgress } from "../../../actions/globalAction";
import trendsImg from "../../../assets/trends.png";
import { Dimmer, Loader } from "semantic-ui-react";
import { setActiveModule } from "../../../actions/sideBarActions";
class Trending extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        if (this.props.packageObj?.package_code !== "enterprise") {
            this.props.configure_progress("whats_trending", this.props.total_fields);
        }
    }

    configureProgress = () => {
        this.props.setModule("Listening");
        localStorage.setItem("activeModule", "Listening");
        this.props.configure_progress("whats_trending", this.props.total_fields);
    };

    render() {
        return (
            <>
                <div className="gs_content">
                    <div className="left_content">
                        <div className="gs_header">
                            <img src={trendsIcon} className="icon_content" />
                            <span className="content_title">{`Trends`}</span>
                        </div>
                        <div className="text_content">
                            <p>{`Are you wondering what is trending right now on Twitter or YouTube.  Fret not, for this section will give you everything you need to know about what’s trending.`}</p>
                            <p>{`You can see Top trends from Twitter Platform and the charts in these sections will display the top trending hashtags in each market.`}</p>
                            <p>{`You can filter by countries that are of interest to you. You can also set a default country.  `}</p>
                            <p>{`Once you have figured out what’s trending right now, why not latch on to the trend by creating and publishing some content?`}</p>
                        </div>

                        {this.props.packageObj?.package_code == "enterprise" ? (
                            <Link to="/twitter-trends">
                                <button className="gs_link" onClick={() => this.configureProgress()}>{`See what's Trending`}</button>
                            </Link>
                        ) : (
                            <div className="no__access__info">*Available in Enterprise package only</div>
                        )}
                    </div>
                    <div className="right_content">
                        <div id="gs_loader">
                            <Dimmer inverted active>
                                <Loader size="big skiptranslate">Loading</Loader>
                            </Dimmer>
                        </div>
                        <iframe
                            width="320px"
                            height="200px"
                            src="https://www.youtube.com/embed/FHF-ILxsFHg?modestbranding=1"
                            title=""
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; gyroscope; picture-in-picture"
                            allowFullScreen
                            onLoad={() => (document.getElementById("gs_loader").style.display = "none")}
                            className="content_video"></iframe>
                        {/* <img className="content-img" src={trendsImg} width="350px" height="200px" /> */}
                    </div>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        packageObj: state.globalReducer.packageObj,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        configure_progress: (field, total) => dispatch(configure_progress(field, total)),
        gettingStartedProgress: () => dispatch(gettingStartedProgress()),
        setModule: (data) => dispatch(setActiveModule(data)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Trending);
